import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4c114a50")

_pushScopeId("data-v-4c114a50")
const _hoisted_1 = { class: "ui__checkContent" }
const _hoisted_2 = { class: "ui__checkContent_item" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "ui_checkContent_List" }
const _hoisted_5 = { class: "ui_checkContent_Li_name" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "ui_checkContent_Li_name_rightMargin" }, null, -1)
const _hoisted_7 = { class: "congValue_container" }
const _hoisted_8 = { class: "congValue_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["ui__checkContent_Buttons", {"more": _ctx.carContentRenderData.length>3}]
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carContentRenderData, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock("button", {
          key: item.areaCode,
          class: ["ui__checkContent_Buttons-button", {"active": _ctx.state.currentIndex === index, 
                    "noFlex1": _ctx.carContentRenderData.length>2 && item.areaName.length > 6,
                    "havedefectItem-style": item.defectItemCount > 0}],
          onClick: ($event: any) => (_ctx.changeContentShowItem(index))
        }, _toDisplayString(item.areaName), 11, ["onClick"])), [
          [_vShow, !_ctx.state.tocOnlyShowFlaw || (_ctx.state.tocOnlyShowFlaw && item.defectItemCount >0)]
        ])
      }), 128))
    ], 2),
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.carContentRenderData, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock("div", {
          class: "ui_checkContent_item_main",
          key: `${_ctx.carContentParentCode}_main_${item.areaCode}`
        }, [
          _createVNode("div", _hoisted_3, [
            (item.imageUrl)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "ui_checkContent__item_img",
                  src: item.imageUrl,
                  alt: ""
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createVNode("ul", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.itemList, (items, indexSon) => {
                return _withDirectives((_openBlock(), _createBlock("li", {
                  class: "ui_checkContent_Li",
                  key: items.checkItemCode
                }, [
                  _createVNode("div", _hoisted_5, [
                    _createTextVNode(_toDisplayString(items.checkItemName) + " ", 1),
                    _hoisted_6
                  ]),
                  (!items.unusual && items.itemDesc !== "受限不可检" &&
                             items.itemDesc !== "无此部件")
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        class: "ui_checkContent_Li_okIcon",
                        src: require("@/assets/toc/ok.png")
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  (!items.unusual && (items.itemDesc === "受限不可检" ||
                             items.itemDesc === "无此部件"))
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: "ui_checkContent_Li_errTip colorGray",
                        onClick: ($event: any) => (_ctx.goToImgView(items))
                      }, [
                        _createVNode("div", _hoisted_7, [
                          _createVNode("span", null, _toDisplayString(items.itemDesc), 1)
                        ]),
                        (items.itemDesc !== "无此部件")
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              src: require("@/assets/tocV3/arrowRightGray.png")
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (items.unusual)
                    ? (_openBlock(), _createBlock("div", {
                        key: 2,
                        class: "ui_checkContent_Li_errTip",
                        onClick: ($event: any) => (_ctx.goToImgView(items, index, indexSon))
                      }, [
                        _createVNode("div", _hoisted_8, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(items.signRuleVOS, (signRule, index) => {
                            return (_openBlock(), _createBlock("span", {
                              key: signRule.defectValueCode,
                              class: _ctx.getCongValueClass(signRule.level,signRule.redSign,_ctx.carContentParentCode)
                            }, _toDisplayString((index === items.signRuleVOS.length - 1) ? _ctx.getCongValueDes(signRule.congValue,signRule.redSign,_ctx.carContentParentCode) : (_ctx.getCongValueDes(signRule.congValue,signRule.redSign,_ctx.carContentParentCode) + '、')), 3))
                          }), 128))
                        ]),
                        _createVNode("img", {
                          src: require("@/assets/tocV3/arrowRightGray.png")
                        }, null, 8, ["src"])
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 512)), [
                  [_vShow, !_ctx.state.tocOnlyShowFlaw || (_ctx.state.tocOnlyShowFlaw && items.unusual)]
                ])
              }), 128))
            ])
          ])
        ], 512)), [
          [_vShow, index === _ctx.state.currentIndex]
        ])
      }), 128))
    ])
  ]))
})